import Header from "./components/Header";
import { Route, Routes, useLocation } from "react-router-dom";
import "./styles/App.scss";
import { IdleTimeoutProvider } from "./context/idleTimoutContext";
import Homepage from "./pages/Homepage";
import Pages from "./pages/Pages";

function App() {
  let location = useLocation();
  // const { showKeyboard, onChange, onKeyPress } = useKeyboard()!;

  return (
    <div className="App">
      <IdleTimeoutProvider>
        <Header />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/pages/:slug" element={<Pages />} />
        </Routes>
        {/* <div className={`step keyboard ${showKeyboard ? "show" : "hide"}`}>
          <Keyboard onChange={onChange} onKeyPress={onKeyPress} />
        </div> */}
      </IdleTimeoutProvider>
    </div>
  );
}

export default App;
